import React, { memo } from 'react'
import { Box } from '@mui/material'

import {
  exchangeLabelForAccount,
  extractMembershipNumber,
  xScreenName
} from '../../util/pointsExchange.helpers'
import AccountCard from './AccountCard'
import { EXCHANGE_PROVIDER_PROFILE_DISPATCH } from '../../store/reducers/exchange/exchangeProviders'
import { CUSTOM_BRAND_ID } from '../../constants/pointsExchange'

const ManageAccounts = ({
  exchangeWhitelist,
  memberships,
  onSaveAccount,
  onQrCodeClick,
  selectedProvider,
  exchangeProviderProfile: { error, accountSaveState, isProcessing },
  onChange,
  earnViaProfile: { screenName, connecting, currentBrandId },
  t
}) => {
  return (
    <>
      <Box
        sx={{
          gap: 3,
          display: 'grid',
          gridTemplateColumns: {
            xs: 'repeat(1, 1fr)',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(3, 1fr)'
          }
        }}
      >
        {exchangeWhitelist?.map((provider, index) => {
          const membership =
            provider.brandId === CUSTOM_BRAND_ID.X
              ? xScreenName(screenName)
              : extractMembershipNumber(memberships, provider)
          return (
            <AccountCard
              key={index}
              label={exchangeLabelForAccount(t, provider)}
              provider={provider}
              membership={membership}
              onSubmit={onSaveAccount}
              t={t}
              isForceBrandIcon={provider.isCrypto}
              onQrCodeClick={() => onQrCodeClick(provider)}
              providerId={selectedProvider?.brandId}
              error={t(
                error[EXCHANGE_PROVIDER_PROFILE_DISPATCH.CONNECT_ACCOUNT_NUMBER]
              )}
              onChange={onChange}
              accountSaveState={accountSaveState}
              loading={
                isProcessing ||
                (connecting && currentBrandId === provider.brandId)
              }
            />
          )
        })}
      </Box>
    </>
  )
}

export default memo(ManageAccounts)
